module.exports = (__webpack_require__(48896))(2352);